import {Component, OnInit} from '@angular/core';
import {WidgetsService} from '../shared/widgets.service';
import {PodValidationWidgetChepManagerData} from '../shared/pod-validation-widget-chep-manager-data.model';
import {NavigationService} from '../../../shared/services/navigation.service';

@Component({
  selector: 'app-widget-pod-chep-manager',
  templateUrl: './widget-pod-chep-manager.component.html',
  styleUrls: ['./widget-pod-chep-manager.component.scss']
})
export class WidgetPodChepManagerComponent implements OnInit {

  podRegions = new PodValidationWidgetChepManagerData();
  totalPodCount = 0;
  refresh = false;
  fetchingData = false;

  constructor(
    private widgetService: WidgetsService,
    private navigationService: NavigationService
  ) { }

  ngOnInit(): void {
    this.getWidgetData(false);
  }

  getWidgetData(forceRefresh: boolean) {
    this.fetchingData = true;
    this.widgetService.getPodValidationChepManagerData(forceRefresh).subscribe(data => {
      this.podRegions = data;
      this.totalPodCount = this.getTotalPodCount(data);
      this.fetchingData = false;
    });
  }

  refreshData() {
    if (this.refresh === false) {
      this.refresh = true;
      this.getWidgetData(true);
      setTimeout(() => this.refresh = false, 1000);
    }
  }

  private getTotalPodCount(data: PodValidationWidgetChepManagerData) {
    return data?.podCountByRegion.reduce((acc, el) => el.count + acc, 0)
  }

  goToRegion(regionId: string) {
    this.navigationService.podsValidation()
      .overall(null, null, [regionId])
      .go()
  }

  goToPodValidation() {
    this.navigationService.podsValidation()
      .overall(null, null, this.podRegions.podCountByRegion.map(value => value.regionId))
      .go()
  }
}
